export var light = {
    baseBrand50: "#f0e8f7",
    baseBrand100: "#e9e0f5",
    baseBrand200: "#bda4e2",
    baseBrand300: "#9c77d4",
    baseBrand400: "#7b49c5",
    baseBrand500: "#5a1cb7",
    baseBrand600: "#481692",
    baseBrand700: "#3f157f",
    baseBrand800: "#300f61",
    baseBrand900: "#1a0835",
    baseSteel50: "#e5e3e8",
    baseSteel100: "#dad7de",
    baseSteel200: "#cac7d0",
    baseSteel300: "#b3afbb",
    baseSteel400: "#7e788b",
    baseSteel500: "#5d566c",
    baseSteel600: "#4d465a",
    baseSteel700: "#3a3543",
    baseSteel800: "#28242e",
    baseSteel900: "#141217",
    baseGray50: "#fcfcfd",
    baseGray100: "#fbfbfc",
    baseGray200: "#faf9fb",
    baseGray300: "#f6f5fa",
    baseGray400: "#f1eef6",
    baseGray500: "#ece8f3",
    baseGray600: "#dcd8e4",
    baseGray700: "#c4bcc8",
    baseGray800: "#a9a2b3",
    baseGray900: "#8a8198",
    baseBlue50: "#f1f6fd",
    baseBlue100: "#e1ecfe",
    baseBlue200: "#bed9fd",
    baseBlue300: "#72a5ee",
    baseBlue400: "#3881e7",
    baseBlue500: "#0661e1",
    baseBlue600: "#0551bd",
    baseBlue700: "#044095",
    baseBlue800: "#032d68",
    baseBlue900: "#021e46",
    baseGreen50: "#f4fbf8",
    baseGreen100: "#d5fbe2",
    baseGreen200: "#c3ead7",
    baseGreen300: "#75c7a1",
    baseGreen400: "#36b579",
    baseGreen500: "#00a357",
    baseGreen600: "#008546",
    baseGreen700: "#006b39",
    baseGreen800: "#00522b",
    baseGreen900: "#00381e",
    baseRed50: "#fce9ea",
    baseRed100: "#fae0e3",
    baseRed200: "#f4c7cc",
    baseRed300: "#e87d88",
    baseRed400: "#dd4151",
    baseRed500: "#d10015",
    baseRed600: "#b20012",
    baseRed700: "#8f000e",
    baseRed800: "#66000a",
    baseRed900: "#420007",
    baseYellow50: "#fdf7f2",
    baseYellow100: "#ffeddb",
    baseYellow200: "#ffddbd",
    baseYellow300: "#ebae75",
    baseYellow400: "#e18733",
    baseYellow500: "#da6900",
    baseYellow600: "#b85800",
    baseYellow700: "#944700",
    baseYellow800: "#6b3400",
    baseYellow900: "#3d1e00",
    baseMagenta50: "#fefbfd",
    baseMagenta100: "#fcebf4",
    baseMagenta200: "#f6cbe0",
    baseMagenta300: "#f0a8cc",
    baseMagenta400: "#e566a5",
    baseMagenta500: "#d91c7a",
    baseMagenta600: "#b61666",
    baseMagenta700: "#8c124f",
    baseMagenta800: "#640c38",
    baseMagenta900: "#430925",
    interactivePrimaryDefault: "#5a1cb7",
    interactivePrimaryActive: "#5a1cb7",
    interactivePrimaryHover: "#481692",
    interactivePrimaryPressed: "#3f157f",
    interactivePrimaryDisabled: "#9c77d4",
    interactiveSuccessDefault: "#00a357",
    interactiveSuccessHover: "#008546",
    interactiveSuccessPressed: "#006b39",
    interactiveSuccessActive: "#006b39",
    interactiveSuccessDisabled: "#75c7a1",
    interactiveWarningDefault: "#da6900",
    interactiveWarningHover: "#b85800",
    interactiveWarningPressed: "#944700",
    interactiveWarningDisabled: "#ebae75",
    interactiveCriticalDefault: "#d10015",
    interactiveCriticalHover: "#b20012",
    interactiveCriticalPressed: "#8f000e",
    interactiveCriticalDisabled: "#e87d88",
    interactiveInfoDefault: "#0661e1",
    interactiveInfoHover: "#0551bd",
    interactiveInfoPressed: "#044095",
    interactiveInfoDisabled: "#72a5ee",
    interactiveNeutralDefault: "#f1eef6",
    interactiveNeutralHover: "#ece8f3",
    interactiveNeutralPressed: "#dcd8e4",
    interactiveNeutralDisabled: "#c4bcc8",
    backgroundViewDarker: "#e5e3e8",
    backgroundViewHoverBackground: "#f0e8f7",
    backgroundViewLighter: "#fbfbfc",
    backgroundViewLight: "#faf9fb",
    backgroundViewApp: "#f6f5fa",
    backgroundViewHover: "#f1eef6",
    backgroundViewNavi: "#ece8f3",
    backgroundViewEdit: "#f5f0fa",
    backgroundViewAppshell: "#faf9fc",
    backgroundSystemInfoLight: "#e8f5fc",
    backgroundSystemInfoDefault: "#e1ecfe",
    backgroundSystemCritcal: "#fae0e3",
    backgroundSystemWarning: "#ffeddb",
    backgroundSystemSuccess: "#d5fbe2",
    backgroundPrivateDefault: "#fff8d1",
    backgroundPrivateLight: "#fffbe5",
    backgroundPrivateDark: "#eae2b8",
    backgroundGradientBrand: "linear-gradient(270deg, #1999E3 0%, #102F7A 100%)",
    backgroundGradientGrowDefault: "linear-gradient(90deg, #BDA4E2 0%, #36116E 100%)",
    backgroundGradientNeutral: "linear-gradient(180deg, #FFFFFF 0%, #F5F8F9 100%)",
    backgroundGradientLead: "linear-gradient(45deg, #174298 0%, #7148bd 50%, #af7ee6 100%)",
    backgroundGradientScale: "linear-gradient(45deg, #117cba 0%, #31bd95 50%, #9be398 100%)",
    backgroundGradientLaunch: "linear-gradient(45deg, #215ab7 0%, #1999e3 50%, #7cccfa 100%)",
    backgroundGradientPurple: "linear-gradient(-90deg, #ca8bdb 30%, #7148bd 70%)",
    backgroundGradientOrange: "linear-gradient(90deg, #de6603 27.46%, #f4bb26 100%)",
    backgroundGradientRed: "linear-gradient(90deg, #FA2D4C 27.46%, #FFDBD4 100%)",
    backgroundGradientLightBlue: "linear-gradient(45deg, #1999E3 0%, #7cccfa 100%)",
    backgroundGradientVideo: "linear-gradient(70.48deg, rgba(23,66,152,0.6) 3.87%, rgba(113,72,189,0.6) 53.52%, rgba(175,126,230,0.6) 94.89%)",
    backgroundGradientVideoOverlay: "linear-gradient(45deg, rgba(23, 66, 152, 0.7) 0%, rgba(113, 72, 189, 0.7) 52%, rgba(175, 126, 230, 0.7) 100%)",
    backgroundGradientFindTimeGray: "repeating-linear-gradient(135deg, #E8EDF1, #E8EDF1 6px, #C7D0D7 6px, #C7D0D7 12px)",
    backgroundGradientFindTimeBlue: "repeating-linear-gradient(135deg, #E9E0F5, #E9E0F5 6px, #BDA4E2 6px, #BDA4E2 12px)",
    backgroundGradientFindTimeViolet: "repeating-linear-gradient(135deg, #6c75c2, #6c75c2 6px, #616ab6 6px, #616ab6 12px)",
    backgroundGradientMask: "linear-gradient(-60deg, #000 30%, #0005, #000 70%) right/300% 100%",
    backgroundGradientRainbow: "linear-gradient(90deg, rgb(113, 72, 189) 0%, rgb(202, 139, 219) 7%, rgb(25, 153, 227) 14%, rgb(124, 204, 250) 21%, rgb(125, 212, 122) 27%, rgb(49, 189, 149) 33.33%, rgb(125, 212, 122) 36%, rgb(124, 204, 250) 42%, rgb(25, 153, 227) 47%, rgb(202, 139, 219) 53%, rgb(113, 72, 189) 60%, rgb(25, 153, 227) 66.66%, rgb(123, 204, 250) 100%)",
    backgroundGradientGrayToTransparent: "linear-gradient(to bottom, rgba(240, 244, 247, 1) 0%, rgba(240, 244, 247, 0) 100%)",
    backgroundGradientTellentDefault: "linear-gradient(90deg, #681D74 0%, #230AC0 100%)",
    backgroundGradientTellentPink: "linear-gradient(90deg, #5A1CB7 0%, #D91C7A 100%)",
    backgroundGradientTellentLightPurple: "linear-gradient(90deg, #F7F4FF 0%, #DED3F2 100%)",
    backgroundGradientAiLightPurple: "linear-gradient(87.33deg, #F7F4FF 3.03%, #DED3F2 98.6%)",
    backgroundGradientAiLightPurpleMagenta: "linear-gradient(-90deg, #F8F2FF 0%, #FCEEF5 100%)",
    backgroundGradientAiPurpleMagenta: "linear-gradient(-90deg, #E9E0F5 0%, #FFD3E9 100%)",
    backgroundGradientAiDarkPurpleMagenta: "linear-gradient(-90deg, #5A1CB7 0%, #D91C7A 100%)",
    backgroundGradientWorkflowsDefault: "linear-gradient(180deg, rgba(255, 141, 65, 1) 0%, rgba(217, 28, 122, 1) 50%, rgba(90, 28, 183, 1) 100%);",
    backgroundGradientWorkflowsLight: "linear-gradient(180deg, rgba(255, 141, 65, 0.1) 0%, rgba(217, 28, 122, 0.1) 50%, rgba(90, 28, 183, 0.1) 100%);",
    backgroundGradientPromote: "linear-gradient(90deg, #F7F3FF 3%, #F4F1FE 12%, #E9DDF4 35%, #E9DDF4 45%, #E9DDF4 68.75%, #E1D2EF 75%, #DACAEB 81.25%, #D3C0E6 87.5%, #CFBCE4 93.75%, #CDB8E2 100%)",
    borderNeutralDefault: "#dcd8e4",
    borderNeutralDark: "#c4bcc8",
    borderNeutralDisabled: "#ece8f3",
    borderNeutralTransparent: "#ffffff4d",
    borderSystemInfo: "#0661e1",
    borderSystemSuccess: "#00a357",
    borderSystemCritical: "#d10015",
    borderSystemWarning: "#da6900",
    borderMainPrimary: "#5a1cb7",
    borderMainActive: "#bda4e2",
    textSystemInfo: "#0551bd",
    textSystemSuccess: "#008546",
    textSystemWarning: "#b85800",
    textSystemCritical: "#b20012",
    textSystemPrimary: "#7627e0",
    textSystemPrimaryDark: "#5a1cb7",
    textMainDefault: "#141217",
    textMainSubdued: "#5d566c",
    textMainDisabled: "#b3afbb",
    textMainActive: "#481692",
    textOnpromoteDefault: "#ffffff",
    iconSystemInfo: "#0661e1",
    iconSystemSuccess: "#00a357",
    iconSystemWarning: "#da6900",
    iconSystemCritical: "#d10015",
    iconSystemPrimary: "#7627e0",
    iconSystemPrimaryDark: "#5a1cb7",
    iconMainBrand: "#5a1cb7",
    iconMainDefault: "#141217",
    iconMainSubdued: "#5d566c",
    iconMainDisabled: "#b3afbb",
    iconMainActive: "#481692",
    miscSpecialPersonal: "#f09300",
    miscSpecialViolet: "#7986cb",
    miscSpecialOrange: "#b25000",
    miscSpecialOrangeLight: "#fae8d9",
    miscSpecialYellow: "#f4bb26",
    miscSpecialIndigo: "#102f7a",
    miscSpecialDarkYellow: "#dadabe",
    miscSpecialDarkBlue: "#113883",
    miscSpecialLime: "#9de000",
    miscSpecialGrayDark: "#6d6976",
    miscSpecialGrayLight: "#ece9f2",
    miscSpecialTurquoise: "#00a4ad",
    miscSpecialTurquoiseLight: "#dcf2f4",
    miscSpecialPurple: "#995ce0",
    miscSpecialPurpleLow: "#dbcff8",
    miscSpecialPurpleLight: "#eae5fa",
    miscSpecialBrown: "#946a57",
    miscSpecialBrownLight: "#f5f1ef",
    miscSocialFacebook: "#1877f2",
    miscSocialTwitter: "#3dacf0",
    miscSocialGooglePlus: "#d34836",
    miscSocialLinkedin: "#0a66c2",
    miscSocialX: "#000000",
    miscPublicDefault: "#31bd95",
    miscPublicHover: "#239e7d",
    miscPublicSubdued: "#eaf8f4",
    pricingScaleDefault: "#d91c7a",
    pricingScaleHover: "#ac1660",
    pricingScaleSubdued: "#fcebf4",
    pricingLeadDefault: "#7148bd",
    pricingLeadHover: "#512fa2",
    pricingLeadSubdued: "#f0ecf8",
    pricingOptimizeDefault: "#7148bd",
    pricingOptimizeHover: "#512fa2",
    pricingOptimizeSubdued: "#f0ecf8",
    pricingGrowDefault: "#d91c7a",
    pricingGrowHover: "#ac1660",
    pricingGrowSubdued: "#fcebf4",
    pricingStartDefault: "#141217",
    pricingStartHover: "#28242e",
    white: "#ffffff",
    black: "#000000",
    colorBgDefault: "#ffffff",
    colorBgHover: "#f1eef6",
    colorBgActive: "#e9e0f5",
    colorBgDisabled: "#dcd8e4",
    colorBgSelected: "#e9e0f5",
    colorBgPrimaryDefault: "#5a1cb7",
    colorBgPrimaryHover: "#481692",
    colorBgPrimaryPressed: "#3f157f",
    colorBgPrimarySelected: "#5a1cb7",
    colorBgPrimaryDisabled: "#9c77d4",
    colorBgPrimarySubduedDefault: "#f0e8f7",
    colorBgPrimarySubduedHover: "#f5f0fa",
    colorBgPrimarySubduedSelected: "#f0e8f7",
    colorBgPrimarySubduedActive: "#f5f0fa",
    colorBgPrimaryStrongDefault: "#481692",
    colorBgPrimaryLowDefault: "#e9e0f5",
    colorBgPrimaryLowHover: "#e9e0f5",
    colorBgPrimaryLowPressed: "#bda4e2",
    colorBgNeutralDefault: "#f6f5fa",
    colorBgNeutralHover: "#ece8f3",
    colorBgNeutralPressed: "#dcd8e4",
    colorBgNeutralDisabled: "#c4bcc8",
    colorBgNeutralSelected: "#f1eef6",
    colorBgNeutralLowDefault: "#faf9fb",
    colorBgNeutralLowHover: "#e5e3e8",
    colorBgNeutralLowDisabled: "#f6f5fa",
    colorBgNeutralStrongDefault: "#dcd8e4",
    colorBgNeutralStrongHover: "#c4bcc8",
    colorBgSuccessDefault: "#00a357",
    colorBgSuccessHover: "#008546",
    colorBgSuccessPressed: "#006b39",
    colorBgSuccessDisabled: "#75c7a1",
    colorBgSuccessLowDefault: "#d5fbe2",
    colorBgSuccessLowHover: "#d5fbe2",
    colorBgSuccessLowPressed: "#d5fbe2",
    colorBgSuccessSubduedDefault: "#d5fbe2",
    colorBgSuccessSubduedHover: "#c3ead7",
    colorBgSuccessSubduedPressed: "#75c7a1",
    colorBgCriticalDefault: "#d10015",
    colorBgCriticalHover: "#b20012",
    colorBgCriticalPressed: "#8f000e",
    colorBgCriticalDisabled: "#e87d88",
    colorBgCriticalLowDefault: "#fae0e3",
    colorBgCriticalLowHover: "#fae0e3",
    colorBgCriticalLowPressed: "#fae0e3",
    colorBgCriticalStrongDefault: "#b20012",
    colorBgCriticalStrongActive: "#8f000e",
    colorBgCriticalSubduedDefault: "#fce9ea",
    colorBgCriticalSubduedHover: "#f4c7cc",
    colorBgCriticalSubduedPressed: "#e87d88",
    colorBgWarningDefault: "#da6900",
    colorBgWarningHover: "#b85800",
    colorBgWarningPressed: "#944700",
    colorBgWarningDisabled: "#ebae75",
    colorBgWarningLowDefault: "#ffeddb",
    colorBgWarningLowHover: "#ffeddb",
    colorBgWarningLowPressed: "#ffeddb",
    colorBgWarningSubduedDefault: "#ffeddb",
    colorBgWarningSubduedHover: "#ffddbd",
    colorBgWarningSubduedPressed: "#ebae75",
    colorBgScaleDefault: "#d91c7a",
    colorBgScaleHover: "#ac1660",
    colorBgScaleSubduedDefault: "#fcebf4",
    colorBgLeadDefault: "#7148bd",
    colorBgLeadHover: "#512fa2",
    colorBgLeadSubduedDefault: "#f0ecf8",
    colorBgPrivateDefault: "#fff8d1",
    colorBgPrivateHover: "#eae2b8",
    colorBgPrivateStrongDefault: "#eae2b8",
    colorBgPrivateLowDefault: "#fffbe5",
    colorBgGradientSubdued: "linear-gradient(180deg, #FFFFFF 0%, #F5F8F9 100%)",
    colorBgSecondaryDefault: "#5d566c",
    colorBgSecondaryDisabled: "#e5e3e8",
    colorBgSecondaryStrongDefault: "#141217",
    colorBgSecondaryStrongHover: "#3a3543",
    colorBgSecondaryStrongPressed: "#4d465a",
    colorBgSecondaryStrongActive: "#28242e",
    colorBgSecondarySubduedDefault: "#dad7de",
    colorBgSecondaryLowDefault: "#7e788b",
    colorBgSecondaryLowDisabled: "#b3afbb",
    colorBgInfoDefault: "#0661e1",
    colorBgInfoHover: "#0551bd",
    colorBgInfoPressed: "#044095",
    colorBgInfoDisabled: "#72a5ee",
    colorBgInfoStrongDefault: "#0551bd",
    colorBgInfoLowDefault: "#e1ecfe",
    colorBgInfoLowHover: "#e1ecfe",
    colorBgInfoLowPressed: "#e1ecfe",
    colorBgOverdueDefault: "#b25000",
    colorBgOverdueLowDefault: "#fae8d9",
    colorBgNoconsentDefault: "#fae8d9",
    colorBgNodataDefault: "#fae8d9",
    colorBgTeamDefault: "#7986cb",
    colorBgPersonalDefault: "#f09300",
    colorBgOverlayDefault: "#24262eb3",
    colorBgOnoverlayHover: "#ffffff1a",
    colorBgOnoverlayPressed: "#ffffff33",
    colorBgGhostHover: "#ffffff1a",
    colorBgGhostPressed: "#ffffff33",
    colorBgTintDefault: "#ffffff4d",
    colorBgLoadingDefault: "#ffffff26",
    colorBgOfferDefault: "#995ce0",
    colorBgOfferHover: "#7d43c3",
    colorBgOfferPressed: "#602d9f",
    colorBgOfferLowDefault: "#eae5fa",
    colorBgOfferLowHover: "#eae5fa",
    colorBgRequisitionSubduedDefault: "#eae5fa",
    colorBgScreeningDefault: "#0551bd",
    colorBgScreeningHover: "#044095",
    colorBgScreeningPressed: "#032d68",
    colorBgScreeningLowDefault: "#e1ecfe",
    colorBgInterviewDefault: "#0661e1",
    colorBgInterviewHover: "#0551bd",
    colorBgInterviewPressed: "#044095",
    colorBgInterviewLowDefault: "#e1ecfe",
    colorBgEvaluationDefault: "#00a4ad",
    colorBgEvaluationHover: "#00858c",
    colorBgEvaluationPressed: "#006a70",
    colorBgEvaluationLowDefault: "#dcf2f4",
    colorBgEvaluationLowHover: "#dcf2f4",
    colorBgJobSubduedDefault: "#dcf2f4",
    colorBgHiredDefault: "#00a357",
    colorBgHiredHover: "#008546",
    colorBgHiredPressed: "#006b39",
    colorBgHiredLowDefault: "#d5fbe2",
    colorBgTranslateDefault: "#da6900",
    colorBgChartDefault: "#5a1cb71a",
    colorBgVersatileSecondaryStrongDefault: "#1e1b22",
    colorBgVersatileSecondaryStrongHover: "#393542",
    colorBgVersatileSecondaryStrongPressed: "#4c4659",
    colorBgVersatileSecondaryStrongActive: "#27242d",
    colorBgVersatileSecondaryDefault: "#5c566a",
    colorBgVersatileSecondaryHover: "#4c4659",
    colorBgVersatileSecondaryMediumDefault: "#393542",
    colorBgVersatileSecondaryMediumHover: "#4c4659",
    colorBgVersatileSecondaryMediumActive: "#5c566a",
    colorBgSkeletonDefault: "#f1eef6",
    colorBgOncomponentDefault: "#ffffff",
    colorBgOncomponentHover: "#ffffff",
    colorBgOncomponentActive: "#ffffff",
    colorBgOptimizeDefault: "#7148bd",
    colorBgOptimizeHover: "#512fa2",
    colorBgOptimizeSubduedDefault: "#f0ecf8",
    colorBgGrowDefault: "#d91c7a",
    colorBgGrowHover: "#ac1660",
    colorBgGrowSubduedDefault: "#fcebf4",
    colorBgStartDefault: "#141217",
    colorBgStartHover: "#28242e",
    colorBgOnboardingDefault: "#a2008c",
    colorBgOnboardingHover: "#a2008c",
    colorBgOnboardingLowDefault: "#ffd7fa",
    colorBgOnboardingLowActive: "#edafe5",
    colorBgOnboardingSubduedDefault: "#ffe3fb",
    colorBgTellentDefault: "#e83393",
    colorBgTellentHover: "#cc287f",
    colorBgTellentPressed: "#951b5c",
    colorBgTellentActive: "#fce3f0",
    colorBgAppliedDefault: "#6d6976",
    colorBgAppliedHover: "#55515c",
    colorBgAppliedPressed: "#37353b",
    colorBgAppliedLowDefault: "#ece9f2",
    colorBgNotypeDefault: "#946a57",
    colorBgNotypeHover: "#7c5442",
    colorBgNotypePressed: "#5f3e30",
    colorBgNotypeLowDefault: "#f5f1ef",
    colorBgKiwiDefault: "#007838",
    colorBgKiwiHover: "#00602d",
    colorBgKiwiPressed: "#004822",
    colorBgKiwiSubduedHover: "#d9ebe1",
    colorBgJaveloDefault: "#d14905",
    colorBgJaveloHover: "#f8e4da",
    colorBgRecruiteeDefault: "#5a1cb7",
    colorBgPublicSubduedDefault: "#eaf8f4",
    colorBgArticleTurquoiseSubduedDefault: "#dcf2f4",
    colorBgArticlePurpleSubduedDefault: "#eae5fa",
    colorBgAccentDefault: "#d91c7a",
    colorBgAccentHover: "#d91c7a",
    colorBgAccentPressed: "#b61666",
    colorBgAccentActive: "#d91c7a",
    colorBgAccentSubduedDefault: "#fcebf4",
    colorBgAccentSubduedHover: "#fcebf4",
    colorBgAccentSubduedPressed: "#fcebf4",
    colorBgAccentStrongDefault: "#b61666",
    colorBgImpactDefault: "#5a1cb7",
    colorBgImpactLowPressed: "#b19cd8",
    colorBgImpactSubduedDefault: "#e9e2f6",
    colorBgImpactSubduedHover: "#eee9f8",
    colorBgAttendanceSubduedDefault: "#ffedf5",
    colorBgEmployeesSubduedDefault: "#fff3e5",
    colorBgTimeoffSubduedDefault: "#e9f3ff",
    colorBgCompanySubduedDefault: "#ebfafb",
    colorBgPayrollSubduedDefault: "#f7e6f8",
    colorBgExpensesSubduedDefault: "#e6e6f4",
    colorBgReportsSubduedDefault: "#e8f9ee",
    colorBgQuoteDefault: "#bb89e0",
    colorBgWorkflowsDefault: "linear-gradient(180deg, rgba(255, 141, 65, 0.1) 0%, rgba(217, 28, 122, 0.1) 50%, rgba(90, 28, 183, 0.1) 100%);",
    colorBgWorkflowsHover: "linear-gradient(180deg, rgba(255, 141, 65, 0.1) 0%, rgba(217, 28, 122, 0.1) 50%, rgba(90, 28, 183, 0.1) 100%);",
    colorBgPromoteDefault: "#591cb5",
    colorBgPromoteHover: "#531aa8",
    colorBgAiSubduedDefault: "#f7f1fd",
    colorBgAiStrongDefault: "#901c9d",
    colorTextDefault: "#5d566c",
    colorTextHover: "#141217",
    colorTextPressed: "#141217",
    colorTextDisabled: "#b3afbb",
    colorTextActive: "#481692",
    colorTextStrongDefault: "#141217",
    colorTextStrongHover: "#141217",
    colorTextStrongSelected: "#141217",
    colorTextLowDefault: "#7e788b",
    colorTextOnprimaryDefault: "#ffffff",
    colorTextOnprimaryHover: "#ffffff",
    colorTextOnprimaryPressed: "#ffffff",
    colorTextOnprimaryDisabled: "#ffffff",
    colorTextOnprimarySelected: "#ffffff",
    colorTextOnneutralDisabled: "#ffffff",
    colorTextOnsuccessDefault: "#ffffff",
    colorTextOnsuccessHover: "#ffffff",
    colorTextOnsuccessPressed: "#ffffff",
    colorTextOncriticalDefault: "#ffffff",
    colorTextOncriticalHover: "#ffffff",
    colorTextOncriticalPressed: "#ffffff",
    colorTextOnwarningDefault: "#ffffff",
    colorTextOnwarningHover: "#ffffff",
    colorTextOnwarningPressed: "#ffffff",
    colorTextSuccessDefault: "#00a357",
    colorTextSuccessHover: "#00a357",
    colorTextSuccessPressed: "#008546",
    colorTextSuccessStrongDefault: "#008546",
    colorTextSuccessStrongHover: "#006b39",
    colorTextSuccessStrongPressed: "#00522b",
    colorTextCriticalDefault: "#d10015",
    colorTextCriticalHover: "#d10015",
    colorTextCriticalPressed: "#b20012",
    colorTextCriticalStrongDefault: "#b20012",
    colorTextCriticalStrongHover: "#8f000e",
    colorTextCriticalStrongPressed: "#66000a",
    colorTextInfoDefault: "#0661e1",
    colorTextInfoHover: "#0661e1",
    colorTextInfoPressed: "#0551bd",
    colorTextInfoStrongDefault: "#0551bd",
    colorTextWarningDefault: "#da6900",
    colorTextWarningHover: "#da6900",
    colorTextWarningPressed: "#b85800",
    colorTextWarningStrongDefault: "#b85800",
    colorTextWarningStrongHover: "#944700",
    colorTextWarningStrongPressed: "#6b3400",
    colorTextOnscaleDefault: "#ffffff",
    colorTextOnscaleHover: "#ffffff",
    colorTextOnleadDefault: "#ffffff",
    colorTextOnleadHover: "#ffffff",
    colorTextScaleDefault: "#d91c7a",
    colorTextScaleHover: "#ac1660",
    colorTextOngradientDefault: "#ffffff",
    colorTextLeadDefault: "#7148bd",
    colorTextOnsecondaryDefault: "#ffffff",
    colorTextOnsecondaryStrongDefault: "#ffffff",
    colorTextOnsecondaryStrongHover: "#ffffff",
    colorTextOnsecondaryStrongPressed: "#ffffff",
    colorTextOninfoStrongDefault: "#ffffff",
    colorTextOninfoDefault: "#ffffff",
    colorTextOninfoHover: "#ffffff",
    colorTextOninfoPressed: "#ffffff",
    colorTextOverdueDefault: "#b25000",
    colorTextOnoverdueDefault: "#ffffff",
    colorTextNoconsentDefault: "#b25000",
    colorTextNodataDefault: "#b25000",
    colorTextOnoverlayDefault: "#ffffff",
    colorTextOnoverlayHover: "#ffffff",
    colorTextOnoverlayPressed: "#ffffff",
    colorTextOnoverlayDisabled: "#7e788b",
    colorTextOnoverlayLowDefault: "#ece8f3",
    colorTextOnghostDefault: "#ffffff",
    colorTextOnghostHover: "#ffffff",
    colorTextOnghostPressed: "#ffffff",
    colorTextOnghostDisabled: "#7e788b",
    colorTextPrimaryDefault: "#5a1cb7",
    colorTextPrimaryHover: "#481692",
    colorTextPrimaryPressed: "#481692",
    colorTextPrimaryActive: "#5a1cb7",
    colorTextPrimaryStrongDefault: "#481692",
    colorTextPrimaryStrongActive: "#481692",
    colorTextOnteamDefault: "#ffffff",
    colorTextOncomponentDefault: "#ffffff",
    colorTextOnoptimizeDefault: "#ffffff",
    colorTextOnoptimizeHover: "#ffffff",
    colorTextOptimizeDefault: "#7148bd",
    colorTextOptimizeHover: "#512fa2",
    colorTextOngrowDefault: "#ffffff",
    colorTextOngrowHover: "#ffffff",
    colorTextGrowDefault: "#d91c7a",
    colorTextGrowHover: "#ac1660",
    colorTextOnstartDefault: "#ffffff",
    colorTextOnstartHover: "#ffffff",
    colorTextOnboardingLowDefault: "#edcfe9",
    colorTextOnboardingDefault: "#57054c",
    colorTextOnonboardingDefault: "#ffffff",
    colorTextOnonboardingHover: "#ffffff",
    colorTextOntellentDefault: "#ffffff",
    colorTextOntellentHover: "#ffffff",
    colorTextOntellentPressed: "#ffffff",
    colorTextOnappliedDefault: "#ffffff",
    colorTextOnappliedHover: "#ffffff",
    colorTextOnappliedPressed: "#ffffff",
    colorTextOnscreeningDefault: "#ffffff",
    colorTextOnscreeningHover: "#ffffff",
    colorTextOnscreeningPressed: "#ffffff",
    colorTextOninterviewDefault: "#ffffff",
    colorTextOninterviewHover: "#ffffff",
    colorTextOninterviewPressed: "#ffffff",
    colorTextOnevaluationDefault: "#ffffff",
    colorTextOnevaluationHover: "#ffffff",
    colorTextOnevaluationPressed: "#ffffff",
    colorTextOnofferDefault: "#ffffff",
    colorTextOnofferHover: "#ffffff",
    colorTextOnofferPressed: "#ffffff",
    colorTextOnhiredDefault: "#ffffff",
    colorTextOnhiredHover: "#ffffff",
    colorTextOnhiredPressed: "#ffffff",
    colorTextOnnotypeDefault: "#ffffff",
    colorTextOnnotypeHover: "#ffffff",
    colorTextOnnotypePressed: "#ffffff",
    colorTextOnkiwiDefault: "#ffffff",
    colorTextOnkiwiHover: "#ffffff",
    colorTextOnkiwiPressed: "#ffffff",
    colorTextOnjaveloDefault: "#ffffff",
    colorTextOnrecruiteeDefault: "#ffffff",
    colorTextRecruiteeDefault: "#5a1cb7",
    colorTextRecruiteeStrongDefault: "#481692",
    colorTextKiwiStrongDefault: "#007838",
    colorTextKiwiDefault: "#007838",
    colorTextAccentDefault: "#d91c7a",
    colorTextAccentHover: "#b61666",
    colorTextAccentPressed: "#b61666",
    colorTextOnaccentDefault: "#ffffff",
    colorTextOnaccentHover: "#ffffff",
    colorTextOnaccentPressed: "#ffffff",
    colorTextImpactDefault: "#5a1cb7",
    colorTextImpactHover: "#481692",
    colorTextImpactPressed: "#481692",
    colorTextAiDefault: "linear-gradient(-90deg, #5A1CB7 0%, #D91C7A 100%)",
    colorTextLinkDefault: "#7627e0",
    colorTextLinkHover: "#5a1cb7",
    colorTextOfferDefault: "#995ce0",
    colorIconDefault: "#5d566c",
    colorIconHover: "#141217",
    colorIconPressed: "#141217",
    colorIconDisabled: "#b3afbb",
    colorIconActive: "#481692",
    colorIconStrongDefault: "#141217",
    colorIconOnprimaryDefault: "#ffffff",
    colorIconOnprimaryHover: "#ffffff",
    colorIconOnprimaryPressed: "#ffffff",
    colorIconOnprimaryDisabled: "#ffffff",
    colorIconOnneutralDisabled: "#ffffff",
    colorIconOnsuccessDefault: "#ffffff",
    colorIconOnsuccessHover: "#ffffff",
    colorIconOnsuccessPressed: "#ffffff",
    colorIconOnsuccessDisabled: "#ffffff",
    colorIconOncriticalDefault: "#ffffff",
    colorIconOncriticalHover: "#ffffff",
    colorIconOncriticalPressed: "#ffffff",
    colorIconOnwarningDefault: "#ffffff",
    colorIconOnwarningHover: "#ffffff",
    colorIconOnwarningPressed: "#ffffff",
    colorIconSuccessDefault: "#00a357",
    colorIconSuccessHover: "#00a357",
    colorIconSuccessPressed: "#008546",
    colorIconSuccessActive: "#006b39",
    colorIconSuccessStrongDefault: "#008546",
    colorIconSuccessStrongHover: "#006b39",
    colorIconSuccessStrongPressed: "#00522b",
    colorIconCriticalDefault: "#d10015",
    colorIconCriticalHover: "#d10015",
    colorIconCriticalPressed: "#b20012",
    colorIconCriticalStrongDefault: "#b20012",
    colorIconCriticalStrongHover: "#8f000e",
    colorIconCriticalStrongPressed: "#66000a",
    colorIconInfoDefault: "#0661e1",
    colorIconInfoHover: "#0661e1",
    colorIconInfoPressed: "#0551bd",
    colorIconInfoStrongDefault: "#0551bd",
    colorIconWarningDefault: "#da6900",
    colorIconWarningHover: "#da6900",
    colorIconWarningPressed: "#b85800",
    colorIconWarningStrongDefault: "#b85800",
    colorIconWarningStrongHover: "#944700",
    colorIconWarningStrongPressed: "#6b3400",
    colorIconScaleDefault: "#d91c7a",
    colorIconScaleHover: "#ac1660",
    colorIconOngradientDefault: "#ffffff",
    colorIconOnscaleDefault: "#ffffff",
    colorIconOnscaleHover: "#ffffff",
    colorIconLeadDefault: "#7148bd",
    colorIconOnleadDefault: "#ffffff",
    colorIconOnleadHover: "#ffffff",
    colorIconOnsecondaryDefault: "#ffffff",
    colorIconOnsecondaryStrongDefault: "#ffffff",
    colorIconOnsecondaryStrongHover: "#ffffff",
    colorIconOninfoStrongDefault: "#ffffff",
    colorIconOninfoDefault: "#ffffff",
    colorIconOninfoHover: "#ffffff",
    colorIconOninfoPressed: "#ffffff",
    colorIconOverdueDefault: "#b25000",
    colorIconOnoverdueDefault: "#ffffff",
    colorIconNoconsentDefault: "#b25000",
    colorIconNodataDefault: "#b25000",
    colorIconOnoverlayDefault: "#ffffff",
    colorIconOnoverlayHover: "#ffffff",
    colorIconOnoverlayPressed: "#ffffff",
    colorIconOnoverlayDisabled: "#7e788b",
    colorIconOnghostDefault: "#ffffff",
    colorIconOnghostHover: "#ffffff",
    colorIconOnghostPressed: "#ffffff",
    colorIconOnghostDisabled: "#7e788b",
    colorIconPrimaryDefault: "#5a1cb7",
    colorIconPrimaryHover: "#481692",
    colorIconPrimaryPressed: "#5a1cb7",
    colorIconPrimaryStrongDefault: "#481692",
    colorIconPrimaryStrongPressed: "#481692",
    colorIconLowDefault: "#7e788b",
    colorIconLowHover: "#5d566c",
    colorIconLowDisabled: "#c4bcc8",
    colorIconSubduedDefault: "#dad7de",
    colorIconOncomponentDefault: "#ffffff",
    colorIconAiDefault: "linear-gradient(-90deg, #5A1CB7 0%, #D91C7A 100%)",
    colorIconAiStrongDefault: "#901c9d",
    colorIconTranslateDefault: "#da6900",
    colorIconOptimizeDefault: "#7148bd",
    colorIconOptimizeHover: "#512fa2",
    colorIconOnoptimizeDefault: "#ffffff",
    colorIconOnoptimizeHover: "#ffffff",
    colorIconGrowDefault: "#d91c7a",
    colorIconGrowHover: "#ac1660",
    colorIconOngrowDefault: "#ffffff",
    colorIconOngrowHover: "#ffffff",
    colorIconOnboardingDefault: "#a2008c",
    colorIconOnboardingLowDefault: "#edcfe9",
    colorIconOnonboardingDefault: "#ffffff",
    colorIconOnonboardingHover: "#ffffff",
    colorIconOnhiredDefault: "#ffffff",
    colorIconOnhiredHover: "#ffffff",
    colorIconOnhiredPressed: "#ffffff",
    colorIconOnkiwiDefault: "#ffffff",
    colorIconOnkiwiHover: "#ffffff",
    colorIconOnkiwiPressed: "#ffffff",
    colorIconOnjaveloDefault: "#ffffff",
    colorIconOnappliedDefault: "#ffffff",
    colorIconOnappliedHover: "#ffffff",
    colorIconOnappliedPressed: "#ffffff",
    colorIconOnscreeningDefault: "#ffffff",
    colorIconOnscreeningHover: "#ffffff",
    colorIconOnscreeningPressed: "#ffffff",
    colorIconOninterviewDefault: "#ffffff",
    colorIconOninterviewHover: "#ffffff",
    colorIconOninterviewPressed: "#ffffff",
    colorIconOnevaluationDefault: "#ffffff",
    colorIconOnevaluationHover: "#ffffff",
    colorIconOnevaluationPressed: "#ffffff",
    colorIconOnofferDefault: "#ffffff",
    colorIconOnofferHover: "#ffffff",
    colorIconOnofferPressed: "#ffffff",
    colorIconOnnotypeDefault: "#ffffff",
    colorIconOnnotypeHover: "#ffffff",
    colorIconOnnotypePressed: "#ffffff",
    colorIconOntellentDefault: "#ffffff",
    colorIconOntellentHover: "#ffffff",
    colorIconOntellentPressed: "#ffffff",
    colorIconTellentDefault: "#e83393",
    colorIconTellentActive: "#e83393",
    colorIconOfferDefault: "#995ce0",
    colorIconEvaluationDefault: "#00a4ad",
    colorIconPublicDefault: "#31bd95",
    colorIconRecruiteeDefault: "#5a1cb7",
    colorIconKiwiDefault: "#007838",
    colorIconRequisitionDefault: "#995ce0",
    colorIconJobDefault: "#00a4ad",
    colorIconArticleTurquoiseDefault: "#00a4ad",
    colorIconArticlePurpleDefault: "#995ce0",
    colorIconAccentDefault: "#d91c7a",
    colorIconAccentHover: "#b61666",
    colorIconAccentPressed: "#b61666",
    colorIconOnaccentDefault: "#ffffff",
    colorIconOnaccentHover: "#ffffff",
    colorIconOnaccentPressed: "#ffffff",
    colorIconImpactDefault: "#5a1cb7",
    colorIconImpactHover: "#481692",
    colorIconImpactPressed: "#481692",
    colorIconAttendanceDefault: "#f65978",
    colorIconTimeoffDefault: "#61a5ff",
    colorIconEmployeesDefault: "#ffaa45",
    colorIconCompanyDefault: "#34d0d7",
    colorIconPayrollDefault: "#c746cb",
    colorIconExpensesDefault: "#0e0bc7",
    colorIconReportsDefault: "#56d586",
    colorIconLinkDefault: "#7627e0",
    colorIconLinkHover: "#5a1cb7",
    colorIconWorkflowsDefault: "linear-gradient(180deg, rgba(255, 141, 65, 1) 0%, rgba(217, 28, 122, 1) 50%, rgba(90, 28, 183, 1) 100%);",
    colorBorderAiDefault: "#e0d1f0",
    colorBorderDefault: "#dcd8e4",
    colorBorderHover: "#dcd8e4",
    colorBorderPressed: "#dcd8e4",
    colorBorderDisabled: "#ece8f3",
    colorBorderSelected: "#dcd8e4",
    colorBorderActive: "#bda4e2",
    colorBorderSuccessDefault: "#00a357",
    colorBorderSuccessHover: "#00a357",
    colorBorderSuccessPressed: "#008546",
    colorBorderSuccessSubduedDefault: "#c3ead7",
    colorBorderSuccessLowDefault: "#36b579",
    colorBorderCriticalDefault: "#d10015",
    colorBorderCriticalHover: "#d10015",
    colorBorderCriticalPressed: "#b20012",
    colorBorderCriticalLowDefault: "#e87d88",
    colorBorderCriticalSubduedDefault: "#f4c7cc",
    colorBorderInfoDefault: "#0661e1",
    colorBorderInfoHover: "#0661e1",
    colorBorderInfoPressed: "#0551bd",
    colorBorderInfoSubduedDefault: "#bed9fd",
    colorBorderWarningDefault: "#da6900",
    colorBorderWarningHover: "#da6900",
    colorBorderWarningPressed: "#b85800",
    colorBorderWarningDisabled: "#ebae75",
    colorBorderWarningSubduedDefault: "#ffddbd",
    colorBorderNeutralHover: "#c4bcc8",
    colorBorderNeutralDisabled: "#f6f5fa",
    colorBorderOncomponentDefault: "#ffffff",
    colorBorderSecondaryDefault: "#5d566c",
    colorBorderSecondaryHover: "#141217",
    colorBorderSecondaryDisabled: "#b3afbb",
    colorBorderSecondaryLowDefault: "#7e788b",
    colorBorderSecondaryLowDisabled: "#cac7d0",
    colorBorderSecondaryStrongDefault: "#3a3543",
    colorBorderPrimaryDefault: "#5a1cb7",
    colorBorderPrimaryHover: "#481692",
    colorBorderPrimaryStrongDefault: "#481692",
    colorBorderPrimarySubduedDefault: "#bda4e2",
    colorBorderPrimaryLowDefault: "#7b49c5",
    colorBorderTranslateDefault: "#da6900",
    colorBorderOnghostDefault: "#ffffff",
    colorBorderOnghostHover: "#ffffff",
    colorBorderOnghostPressed: "#ffffff",
    colorBorderOnghostDisabled: "#7e788b",
    colorBorderPrivateDefault: "#dadabe",
    colorBorderStrongDefault: "#c4bcc8",
    colorBorderStrongDisabled: "#c4bcc8",
    colorBorderLowDefault: "#ece8f3",
    colorBorderLowHover: "#dad7de",
    colorBorderTeamDefault: "#7986cb",
    colorBorderVersatileSecondaryDefault: "#5c566a",
    colorBorderTintDefault: "#ffffff4d",
    colorBorderAccentDefault: "#d91c7a",
    colorBorderAccentHover: "#b61666",
    colorBorderAccentPressed: "#b61666",
    colorBorderAccentSubduedDefault: "#f6cbe0",
    colorBorderImpactDefault: "#b19cd8",
    colorBorderImpactHover: "#b19cd8",
    colorBorderImpactPressed: "#b19cd8",
    colorBorderOnprimaryDefault: "#ffffff",
    colorBorderOnprimaryHover: "#ffffff",
    colorBorderOnprimaryPressed: "#ffffff",
    colorBorderOfferSubduedDefault: "#dbcff8",
    colorGradientPrimary: "linear-gradient(270deg, #1999E3 0%, #102F7A 100%)",
    colorGradientLaunch: "linear-gradient(45deg, #215ab7 0%, #1999e3 50%, #7cccfa 100%)",
    colorGradientScale: "linear-gradient(45deg, #117cba 0%, #31bd95 50%, #9be398 100%)",
    colorGradientLead: "linear-gradient(45deg, #174298 0%, #7148bd 50%, #af7ee6 100%)",
    colorGradientPurple: "linear-gradient(-90deg, #ca8bdb 30%, #7148bd 70%)",
    colorGradientOrange: "linear-gradient(90deg, #de6603 27.46%, #f4bb26 100%)",
    colorGradientRed: "linear-gradient(90deg, #FA2D4C 27.46%, #FFDBD4 100%)",
    colorGradientLightBlue: "linear-gradient(45deg, #1999E3 0%, #7cccfa 100%)",
    colorGradientVideo: "linear-gradient(70.48deg, rgba(23,66,152,0.6) 3.87%, rgba(113,72,189,0.6) 53.52%, rgba(175,126,230,0.6) 94.89%)",
    colorGradientVideoOverlay: "linear-gradient(45deg, rgba(23, 66, 152, 0.7) 0%, rgba(113, 72, 189, 0.7) 52%, rgba(175, 126, 230, 0.7) 100%)",
    colorGradientFindTimeNeutral: "repeating-linear-gradient(135deg, #E8EDF1, #E8EDF1 6px, #C7D0D7 6px, #C7D0D7 12px)",
    colorGradientFindTimePrimary: "repeating-linear-gradient(135deg, #E9E0F5, #E9E0F5 6px, #BDA4E2 6px, #BDA4E2 12px)",
    colorGradientFindTimeViolet: "repeating-linear-gradient(135deg, #6c75c2, #6c75c2 6px, #616ab6 6px, #616ab6 12px)",
    colorGradientTruncate: "#ffffff00",
    colorGradientShimmer: "linear-gradient(-60deg, #000 30%, #0005, #000 70%) right/300% 100%",
    colorGradientRainbow: "linear-gradient(90deg, rgb(113, 72, 189) 0%, rgb(202, 139, 219) 7%, rgb(25, 153, 227) 14%, rgb(124, 204, 250) 21%, rgb(125, 212, 122) 27%, rgb(49, 189, 149) 33.33%, rgb(125, 212, 122) 36%, rgb(124, 204, 250) 42%, rgb(25, 153, 227) 47%, rgb(202, 139, 219) 53%, rgb(113, 72, 189) 60%, rgb(25, 153, 227) 66.66%, rgb(123, 204, 250) 100%)",
    colorGradientNeutralToTransparent: "linear-gradient(to bottom, rgba(240, 244, 247, 1) 0%, rgba(240, 244, 247, 0) 100%)",
    colorGradientTellent: "linear-gradient(90deg, #681D74 0%, #230AC0 100%)",
    colorGradientPink: "linear-gradient(90deg, #5A1CB7 0%, #D91C7A 100%)",
    colorGradientImpact: "linear-gradient(90deg, #F7F4FF 0%, #DED3F2 100%)",
    colorGradientAiDefault: "linear-gradient(-90deg, #E9E0F5 0%, #FFD3E9 100%)",
    colorGradientAiSubduedDefault: "linear-gradient(-90deg, #F8F2FF 0%, #FCEEF5 100%)",
    colorGradientAiStrongDefault: "linear-gradient(-90deg, #5A1CB7 0%, #D91C7A 100%)",
    colorGradientGrow: "linear-gradient(90deg, #BDA4E2 0%, #36116E 100%)",
    colorGradientWorkflows: "linear-gradient(180deg, rgba(255, 141, 65, 1) 0%, rgba(217, 28, 122, 1) 50%, rgba(90, 28, 183, 1) 100%);",
    colorGradientWorkflowsLight: "linear-gradient(180deg, rgba(255, 141, 65, 0.1) 0%, rgba(217, 28, 122, 0.1) 50%, rgba(90, 28, 183, 0.1) 100%);",
    colorGradientPromote: "linear-gradient(90deg, #F7F3FF 3%, #F4F1FE 12%, #E9DDF4 35%, #E9DDF4 45%, #E9DDF4 68.75%, #E1D2EF 75%, #DACAEB 81.25%, #D3C0E6 87.5%, #CFBCE4 93.75%, #CDB8E2 100%)",
    colorTooltipFeature: "#113883",
    colorTooltipFeatureLight: "#198fd9",
    colorAvatarSteelLighter: "#7055aa",
    colorAvatarSteelLight: "#dad7de",
    colorAvatarSteelDark: "#5d566c",
    colorAvatarGrayLight: "#ece8f3",
    colorAvatarGrayDark: "#8a8198",
    colorAvatarGreen: "#048b5d",
    colorAvatarBlueLight: "#147ab6",
    colorAvatarBlueDark: "#b7427c",
    colorAvatarBlueDarker: "#300f61",
    colorAvatarPink: "#9a4cb6",
    colorAvatarPurple: "#512fa2",
    colorAvatarYellow: "#da6900",
    colorAvatarOrange: "#b25000",
    colorAvatarSkeleton: "#f1eef6",
    colorChartPrimaryDefault: "#8659ca",
    colorChartBlueDefault: "#f47174",
    colorChartTurquoiseDefault: "#008ee5",
    colorChartPurpleDefault: "#e566a5",
    colorChartPurpleSubduedDefault: "#03ad9c",
    colorChartGrayDefault: "#a6a2af",
    colorChartGreenDefault: "#45c2d1",
    colorChartGreenSubduedDefault: "#cd75bc",
    colorChartBlueStrongDefault: "#ffd76f",
    colorChartYellowDefault: "#feb07b",
    colorChartYellowSubduedDefault: "#6871ee",
    colorChartOrangeDefault: "#b2a1f7",
    colorSeparatorTransparent: "#ffffff4d",
    colorLogoTypographyDefault: "#5a1cb7",
    colorLogoTypographyStrongDefault: "#330066",
    colorLogoSignSubduedDefault: "#ece0f5",
    colorLogoSignPrimaryDefault: "#5a1cb7",
    colorLogoSignAccentDefault: "#e23393",
    colorCandidatesBgPrimaryDefault: "#8659ca",
    colorCandidatesBgGreenStrongDefault: "#1ea275",
    colorCandidatesBgOrangeDefault: "#de6603",
    colorCandidatesBgYellowDefault: "#f4bb26",
    colorCandidatesBgGreenSubduedDefault: "#31bd95",
    colorCandidatesBgBlueDefault: "#0c6090",
    colorCandidatesBgVioletDefault: "#512fa2",
    colorCandidatesBgGreenDefault: "#4fc510",
    colorCandidatesBgBlueStrongDefault: "#083f5e",
    colorCandidatesBgPurpleDefault: "#9a4cb6",
    colorCandidatesBorderPrimaryDefault: "#8659ca",
    colorCandidatesBorderGreenStrongDefault: "#1ea275",
    colorCandidatesBorderOrangeDefault: "#de6603",
    colorCandidatesBorderYellowDefault: "#f4bb26",
    colorCandidatesBorderGreenSubduedDefault: "#31bd95",
    colorCandidatesBorderBlueDefault: "#0c6090",
    colorCandidatesBorderVioletDefault: "#512fa2",
    colorCandidatesBorderGreenDefault: "#4fc510",
    colorCandidatesBorderBlueStrongDefault: "#083f5e",
    colorCandidatesBorderPurpleDefault: "#9a4cb6",
    colorScrollbarThumbDefault: "#c7c7c7",
    colorScrollbarThumbHover: "#878787",
    colorScrollbarTrackDefault: "#fafafa",
    colorMarketplaceLogo: "#f1f4f7",
    colorMarketplaceRibbon: "#006b39",
    colorVersatileDefault: "#ffffff",
    colorFacebookDefault: "#1877f2",
    colorXDefault: "#000000",
    colorGoogleplusDefault: "#d34836",
    colorLinkedinDefault: "#0a66c2",
    colorNavBgNeutralDefault: "#faf9fc",
    colorNavBgNeutralLowHover: "#ece8f3",
    colorNavBgActive: "#e9e0f5",
    colorNavBgPrimarySubduedDefault: "#ece0f5",
    colorNavTextDefault: "#5d566c",
    colorNavTextStrongDefault: "#141217",
    colorNavTextPrimaryActive: "#5a1cb7",
    colorNavTextLowDefault: "#7e788b",
    colorNavIconDefault: "#5d566c",
    colorNavIconStrongDefault: "#141217",
    colorNavIconPrimaryDefault: "#5a1cb7",
    colorNavIconDisabled: "#b3afbb",
    colorNavBorderDefault: "#dcd8e4",
    shadow100: "0 2px 5px 0 rgba(0,0,0,0.02), 0 1px 1px 0 rgba(0,0,0,0.08)",
    shadow200: "0 2px 5px 0 rgba(0,0,0,0.08), 0 1px 2px 0 rgba(0,0,0,0.08)",
    shadow300: "0 4px 4px 0 rgba(0,0,0,0.02), 0 4px 8px 0 rgba(0,0,0,0.04), 0 2px 2px 0 rgba(0,0,0,0.04), 0 0 1px 0 rgba(0,0,0,0.04)",
    shadow400: "0 26px 10px 0 rgba(0,0,0,0.01), 0 15px 9px 0 rgba(0,0,0,0.02), 0 7px 7px 0 rgba(0,0,0,0.03), 0 2px 12px 0 rgba(0,0,0,0.08)",
    shadow500: "0 4px 28px 0 rgba(0,0,0,0.16)",
    shadow600: "0 0 32px 0 rgba(0,0,0,0.50)",
    shadowBase100: "0 2px 5px 0 rgba(0,0,0,0.02), 0 1px 1px 0 rgba(0,0,0,0.08)",
    shadowNavSwitcherHover: "0 2px 5px 0 rgba(0,0,0,0.02), 0 1px 1px 0 rgba(0,0,0,0.08)",
    shadowNavSwitcherActive: "0 2px 5px 0 rgba(0,0,0,0.08), 0 1px 2px 0 rgba(0,0,0,0.08)",
    shadowNavHovered: "0 3px 30px 0 rgba(0,0,0,0.15)",
    shadowInteraction200: "0 2px 5px 0 rgba(0,0,0,0.08), 0 1px 2px 0 rgba(0,0,0,0.08)",
    shadowWysiwigToolbarTop: "0 -2px 5px 0 rgba(0,0,0,0.08), 0 -1px 2px 0 rgba(0,0,0,0.08)",
    shadowToast300: "0 4px 4px 0 rgba(0,0,0,0.02), 0 4px 8px 0 rgba(0,0,0,0.04), 0 2px 2px 0 rgba(0,0,0,0.04), 0 0 1px 0 rgba(0,0,0,0.04)",
    shadowDropdown400: "0 26px 10px 0 rgba(0,0,0,0.01), 0 15px 9px 0 rgba(0,0,0,0.02), 0 7px 7px 0 rgba(0,0,0,0.03), 0 2px 12px 0 rgba(0,0,0,0.08)",
    shadowFloat500: "0 4px 28px 0 rgba(0,0,0,0.16)",
    shadowDialog600: "0 0 32px 0 rgba(0,0,0,0.50)",
    shadowBorderFormFocusDefault: "0 0 0 3px rgba(115,38,248,0.2)",
    shadowBorderFormFocusTranslate: "0 0 0 1px rgba(240,154,15,1)",
    shadowBorderFormHoverCritical: "0 0 0 1px #e50101",
    shadowBorderCardActive: "0 0 0 4px rgba(90,28,183,0.2)",
    shadowBorderCardDefault: "0 0 0 1px #dcd8e4",
    shadowBorderCardHover: "0 0 0 2px rgba(90,28,183)",
    shadowBorderCardOnboarding: "0 0 0 1px rgba(26,182,22,1)",
    shadowBorderStepActive: "0 0 0 4px rgba(90,28,183,0.2)",
    shadowBorderAvatarPrivate: "0 0 0 2px rgba(253,245,231,1)",
    shadowBorderAvatarAdmin: "0 0 0 2px #F0F4F7",
    shadowInnerCardPressed: "inset 0 2px 2px 0 rgba(0,0,0,0.12)",
    shadowInnerContentTop: "inset 0 4px 4px 0 rgba(0,0,0,0.8)",
    shadowInnerContentBottom: "inset 0 -4px 4px 0 rgba(0,0,0,0.8)",
    shadowInnerContentLeft: "inset 4px 0 4px 0 rgba(0,0,0,0.8)",
    shadowInnerContentRight: "inset -4px 0 4px 0 rgba(0,0,0,0.8)",
    tellentShadowBorderFormFocusDefault: "0 0 0 3px rgba(90,28,183,0.2)",
    tellentShadowBorderCardActive: "0 0 0 4px rgba(90,28,183,0.2)",
    tellentShadowBorderCardHover: "0 0 0 2px rgba(90,28,183,1)",
    kiwiShadowBorderFormFocusDefault: "0 0 0 2px rgba(0,120,56,0.2)",
    kiwiShadowBorderCardActive: "0 0 0 4px rgba(90,28,183,0.2)",
    kiwiShadowBorderCardHover: "0 0 0 2px rgba(0,120,56,1)",
    avatarSteelLighter: "#7055aa",
    avatarSteelLight: "#dad7de",
    avatarSteelDark: "#5d566c",
    avatarGrayLight: "#ece8f3",
    avatarGrayDark: "#8a8198",
    avatarGreen: "#048b5d",
    avatarBlueLight: "#147ab6",
    avatarBlueDark: "#b7427c",
    avatarBlueDarker: "#300f61",
    avatarPink: "#9a4cb6",
    avatarPurple: "#512fa2",
    avatarYellow: "#da6900",
    avatarOrange: "#b25000",
    avatarSkeleton: "#f1eef6",
    chartBrandDefault: "#8659ca",
    chartSkyDefault: "#f47174",
    chartOceanDefault: "#008ee5",
    chartOrchidDefault: "#e566a5",
    chartLavenderDefault: "#03ad9c",
    chartSteelDefault: "#a6a2af",
    chartEmeraldDefault: "#45c2d1",
    chartMintDefault: "#cd75bc",
    chartCobaltDefault: "#ffd76f",
    chartSunflowerDefault: "#feb07b",
    chartLemonDefault: "#6871ee",
    chartPumpkinDefault: "#b2a1f7",
    candidatesBgBrandDefault: "#8659ca",
    candidatesBgRainforestDefault: "#1ea275",
    candidatesBgFireDefault: "#de6603",
    candidatesBgGoldDefault: "#f4bb26",
    candidatesBgJungleDefault: "#31bd95",
    candidatesBgNavyDefault: "#0c6090",
    candidatesBgEggplantDefault: "#512fa2",
    candidatesBgGrassDefault: "#4fc510",
    candidatesBgDenimDefault: "#083f5e",
    candidatesBgLilacDefault: "#9a4cb6",
    candidatesBorderBrandDefault: "#8659ca",
    candidatesBorderRainforestDefault: "#1ea275",
    candidatesBorderFireDefault: "#de6603",
    candidatesBorderGoldDefault: "#f4bb26",
    candidatesBorderJungleDefault: "#31bd95",
    candidatesBorderNavyDefault: "#0c6090",
    candidatesBorderEggplantDefault: "#512fa2",
    candidatesBorderGrassDefault: "#4fc510",
    candidatesBorderDenimDefault: "#083f5e",
    candidatesBorderLilacDefault: "#9a4cb6",
    aiDefault: "linear-gradient(-90deg, #E9E0F5 0%, #FFD3E9 100%)",
    aiStrongDefault: "linear-gradient(-90deg, #5A1CB7 0%, #D91C7A 100%)",
    aiSubduedDefault: "linear-gradient(-90deg, #F8F2FF 0%, #FCEEF5 100%)",
    productRecruitee50: "#f0e8f7",
    productRecruitee100: "#e9e0f5",
    productRecruitee200: "#bda4e2",
    productRecruitee300: "#9c77d4",
    productRecruitee400: "#7b49c5",
    productRecruitee500: "#5a1cb7",
    productRecruitee600: "#481692",
    productRecruitee700: "#3f157f",
    productRecruitee800: "#300f61",
    productRecruitee900: "#1a0835",
    productKiwi50: "#f8fffb",
    productKiwi100: "#d9ebe1",
    productKiwi200: "#95c9ad",
    productKiwi300: "#63ae86",
    productKiwi400: "#32935f",
    productKiwi500: "#007838",
    productKiwi600: "#00602d",
    productKiwi700: "#004822",
    productKiwi800: "#003016",
    productKiwi900: "#002411",
    productJavelo50: "#fff5f0",
    productJavelo100: "#f8e4da",
    productJavelo200: "#ecaa89",
    productJavelo300: "#e38a5d",
    productJavelo400: "#da6931",
    productJavelo500: "#d14905",
    productJavelo600: "#a73a04",
    productJavelo700: "#7d2c03",
    productJavelo800: "#541d02",
    productJavelo900: "#3f1602",
    productTellent50: "#fdebf4",
    productTellent100: "#fce3f0",
    productTellent200: "#f6b3d7",
    productTellent300: "#ef73b5",
    productTellent400: "#ec53a4",
    productTellent500: "#e83393",
    productTellent600: "#cc287f",
    productTellent700: "#951b5c",
    productTellent800: "#5e0b37",
    productTellent900: "#420027",
    onboardingBackgroundDefault: "#a2008c",
    onboardingBackgroundLoader: "#edafe5",
    onboardingBackgroundLow: "#ffd7fa",
    onboardingBackgroundSubdued: "#ffe3fb",
    onboardingTextDefault: "#57054c",
    onboardingTextLow: "#edcfe9",
    onboardingIconDefault: "#a2008c",
    onboardingIconLow: "#edcfe9",
    articleOceanDefault: "#00a4ad",
    articleOceanSubduedDefault: "#dcf2f4",
    articleOrchidDefault: "#995ce0",
    articleOrchidSubduedDefault: "#eae5fa",
    billingPink: "#f65978",
    billingPinkLight: "#ffedf5",
    billingOrange: "#ffaa45",
    billingOrangeLight: "#fff3e5",
    billingBlue: "#61a5ff",
    billingBlueLight: "#e9f3ff",
    billingTurquoise: "#34d0d7",
    billingTurquoiseLight: "#ebfafb",
    billingPurple: "#c746cb",
    billingPurpleLight: "#f7e6f8",
    billingNavy: "#0e0bc7",
    billingNavyLight: "#e6e6f4",
    billingGreen: "#56d586",
    billingGreenLight: "#e8f9ee",
    buttonPrimaryShadowDefault: "0 2px 5px 0 rgba(0,0,0,0.08), 0 1px 2px 0 rgba(0,0,0,0.08)",
};
